document.addEventListener('DOMContentLoaded', function() {
  var swiper = new Swiper('.swiper-container', {
      slidesPerView: 'auto',
      spaceBetween: 10,
      centeredSlides: true,
      navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
      },
      scrollbar: {
          el: '.swiper-scrollbar',
          draggable: true,
      },
      grabCursor: true,
      freeMode: false,
      loop: false,
      autoHeight: true,
      mousewheel: {
          enabled: false,
      },
  });

  var swiperContainer = document.querySelector('.swiper-container');

  swiperContainer.addEventListener('mouseenter', function() {
      swiper.params.mousewheel.enabled = true;
      swiper.mousewheel.enable();
  });

  swiperContainer.addEventListener('mouseleave', function() {
      swiper.params.mousewheel.enabled = false;
      swiper.mousewheel.disable();
  });
});
